import { render, staticRenderFns } from "./organigramPage.vue.html?vue&type=template&id=4d880a35"
import script from "./organigramPage.controller?vue&type=script&lang=js&external"
export * from "./organigramPage.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports